(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kf-language-picker"] && !Shopify.designMode) return;
  try {
    const localizationHeader = document.querySelector('.kf-header');
  if (localizationHeader) {
    const updateLocalizationHeaderHeight = () => {
      document.documentElement.style.setProperty('--kf-header-height', `${localizationHeader.getBoundingClientRect().height}px`);
    };
    new ResizeObserver(updateLocalizationHeaderHeight).observe(localizationHeader);
    updateLocalizationHeaderHeight();
  }

  document.addEventListener('submit', (event) => {
    if (!event.target.matches('.kf-language-form, .kf-country-form')) return;
    const returnTo = event.target.querySelector('input[name="return_to"]');
    const url = new URL(window.location.href);
    url.searchParams.delete('country');
    url.searchParams.delete('currency');
    if (returnTo) returnTo.value = url.pathname + url.search;
  });
  document.addEventListener('toggle', (event) => {
    const picker = event.target;
    if (!picker.matches('.kf-language-picker') || !picker.open) return;
    document.querySelectorAll('.kf-language-picker[open]').forEach((other) => {
      if (other !== picker) other.open = false;
    });
  }, true);
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.kf-language-picker[open]').forEach((picker) => {
      if (!picker.contains(event.target)) picker.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.kf-language-picker[open]').forEach((picker) => {
      const restoreFocus = picker.contains(document.activeElement);
      picker.open = false;
      if (restoreFocus) picker.querySelector('summary').focus();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
